import React from "react";
import { useParams } from "react-router-dom";

import Loading from "components/Loading";
import NewWorkbookButton from "components/NewWorkbookButton";
import WorkbookListTable from "components/WorkbookListTable";

import { useWorkbooksForServerQuery } from "./gql/Query.generated";

const ServerWorkbookList = () => {
  const { serverId } = useParams();
  const { loading, error, data, refetch } = useWorkbooksForServerQuery({
    variables: { serverId },
  });

  if (loading || error || !data) {
    return <Loading error={!!error} />;
  }

  return (
    <WorkbookListTable
      workbooks={data.getWorkbooks}
      showDatabaseColumn
      onDeleted={() => {
        refetch();
      }}
      toolbar={<NewWorkbookButton />}
    />
  );
};

export default ServerWorkbookList;
